var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"edit-sidebar"},[(this.admin)?void 0:_vm._e()],2),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('dashboard-menu-item',{key:item.id,attrs:{"adminmode":_vm.adminmode,"item":item},on:{"item-updated":function($event){return _vm.updateItem($event)}}})})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5649df1d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/admin/dashboardMenu.vue
// module id = RBVO
// module chunks = 0